<template>
    <ModalWrapper v-model="isShowVoucherDialog" max-width="500">
        <template v-slot:title>
            {{ title }}
        </template>
        <template v-slot:content>
            <v-form v-model="valid" @submit.prevent>
                <v-radio-group v-model="voucherType" class="ms-n2">
                    <v-radio
                        v-for="(type, i) in voucherTypes"
                        :key="type"
                        color="primary"
                        :label="`${type}`"
                        :value="i"
                        :data-cy="type"
                    />
                </v-radio-group>
                <v-text-field
                    v-if="voucherType === 1"
                    v-model="voucherEmail"
                    :label="`${$t('email')}*`"
                    type="email"
                    autocomplete="email"
                    :rules="validationRules('email', [emailRule, requiredRule])"
                />
                <slot :voucher-type="voucherType" />
            </v-form>
        </template>
        <template v-slot:btns>
            <v-btn
                variant="flat"
                :disabled="!valid && voucherType === 1"
                color="primary"
                :loading="isLoading"
                @click="processVoucher"
            >
                {{ $t('ok') }}
            </v-btn>
        </template>
    </ModalWrapper>
</template>

<script lang="ts">
    import {Component, Emit, mixins, Prop, VModel} from 'vue-facing-decorator'
    import {FormValidationRulesMixin} from '@/mixins/FormValidationRulesMixin.vue'

    @Component({
        components: {},
    })
    export class VoucherDialog extends mixins(FormValidationRulesMixin) {
        @VModel() isShowVoucherDialog
        @Prop({required: true}) title
        @Prop({required: true}) isLoading

        voucherType = 0
        voucherEmail = ''
        valid = false

        processVoucher() {
            switch (this.voucherType) {
                case 0:
                    this.downloadVoucher()
                    break
                default:
                    this.sendOnEmail()
                    break
            }
        }

        @Emit()
        sendOnEmail() {
            return this.voucherEmail
        }

        @Emit()
        downloadVoucher() {}

        get voucherTypes() {
            return [`${this.$t('download')} PDF`, `${this.$t('send_to_email')}`]
        }

        get order() {
            return runtimeStore.orderDetails
        }
    }

    export default VoucherDialog
</script>
